var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.error
      ? _c(
          "div",
          [
            _c("v-alert", { attrs: { type: "error", value: true } }, [
              _vm._v("\n\t\t\t" + _vm._s(_vm.error) + "\n\t\t")
            ])
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "v-form",
              { ref: "vantage_form" },
              [
                _vm.form.parameters.hasOwnProperty("workflow_id")
                  ? _c(
                      "v-layout",
                      { staticClass: "pt-3", attrs: { row: "", wrap: "" } },
                      [
                        _c("v-autocomplete", {
                          staticClass: "my-0 py-0",
                          attrs: {
                            label: "Workflow Vantage",
                            loading: _vm.loading_vantage_workflows,
                            clearable: "",
                            dense: "",
                            autofocus: "",
                            "persistent-hint": "",
                            "menu-props": { maxHeight: "80vh" },
                            hint: _vm.selected_workflow_hint,
                            rules: [_vm.required],
                            "item-value": "id",
                            "item-text": "name",
                            items: _vm.vantage_workflows
                          },
                          on: {
                            change: function($event) {
                              return _vm.emitChange()
                            },
                            "click:clear": function($event) {
                              _vm.form.parameters.workflow_id = ""
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(data) {
                                  return [
                                    _c(
                                      "v-list-tile-content",
                                      { staticClass: "pl-2" },
                                      [
                                        _c("v-list-tile-title", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(data.item.name) +
                                              "\n\t\t\t\t\t\t\t"
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              },
                              {
                                key: "item",
                                fn: function(data) {
                                  return [
                                    data.item.type === "header"
                                      ? [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(data.item.header) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ]
                                      : [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(data.item.name) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      data.item.description ||
                                                        "-"
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t"
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-action", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm._f("formatDateNoTime")(
                                                    data.item.mod_date
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t"
                                            )
                                          ])
                                        ]
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1085074762
                          ),
                          model: {
                            value: _vm.form.parameters.workflow_id,
                            callback: function($$v) {
                              _vm.$set(_vm.form.parameters, "workflow_id", $$v)
                            },
                            expression: "form.parameters.workflow_id"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.form.parameters.hasOwnProperty("label")
                  ? _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "", "align-center": "" } },
                      [
                        _c("v-text-field", {
                          attrs: { label: "label" },
                          on: {
                            change: function($event) {
                              return _vm.emitChange()
                            }
                          },
                          model: {
                            value: _vm.form.parameters.label,
                            callback: function($$v) {
                              _vm.$set(_vm.form.parameters, "label", $$v)
                            },
                            expression: "form.parameters.label"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.form.parameters.hasOwnProperty("priority")
                  ? _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "", "align-center": "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { shrink: "" } },
                          [
                            _c(
                              "v-chip",
                              {
                                staticClass:
                                  "black--text font-weight-bold ml-0",
                                attrs: { color: _vm.priority_color }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\tPriorité " +
                                    _vm._s(_vm.form.parameters.priority) +
                                    "\n\t\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { grow: "" } },
                          [
                            _c("v-slider", {
                              attrs: {
                                min: "0",
                                max: "10",
                                "prepend-icon": "remove",
                                "append-icon": "add",
                                color: _vm.priority_color
                              },
                              on: {
                                change: function($event) {
                                  return _vm.emitChange()
                                },
                                "click:prepend": function($event) {
                                  _vm.form.parameters.priority--
                                  _vm.emitChange()
                                },
                                "click:append": function($event) {
                                  _vm.form.parameters.priority++
                                  _vm.emitChange()
                                }
                              },
                              model: {
                                value: _vm.form.parameters.priority,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.parameters,
                                    "priority",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "form.parameters.priority"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.form.parameters.hasOwnProperty("asset_list")
                  ? _c(
                      "span",
                      _vm._l(_vm.form.parameters.asset_list, function(
                        asset,
                        i
                      ) {
                        return _c(
                          "v-layout",
                          {
                            key: "asset_" + i,
                            staticClass: "mb-1 asset-card",
                            attrs: { row: "", wrap: "", "align-center": "" }
                          },
                          [
                            _c(
                              "v-flex",
                              { attrs: { shrink: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0",
                                    attrs: {
                                      flat: "",
                                      icon: "",
                                      color: "warning"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeAsset(i)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("close")])],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { grow: "" } }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(asset) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          ],
                          1
                        )
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.form.parameters.hasOwnProperty("asset_list")
                  ? _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "ml-0 text-none",
                            attrs: { color: "primary color--text" },
                            on: {
                              click: function($event) {
                                _vm.showExplorer = true
                              }
                            }
                          },
                          [
                            _c("v-icon", { staticClass: "mr-2" }, [
                              _vm._v("folder")
                            ]),
                            _vm._v("\n\t\t\t\t\tExplorer\n\t\t\t\t")
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ml-0 text-none",
                            attrs: { color: "primary color--text" },
                            on: {
                              click: function($event) {
                                _vm.showAssetFinder = true
                              }
                            }
                          },
                          [
                            _c("v-icon", { staticClass: "mr-2" }, [
                              _vm._v("search")
                            ]),
                            _vm._v("\n\t\t\t\t\tAsset finder\n\t\t\t\t")
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ml-0 text-none",
                            attrs: { color: "primary color--text" },
                            on: {
                              click: function($event) {
                                _vm.showTitleAssetFinder = true
                              }
                            }
                          },
                          [
                            _c("v-icon", { staticClass: "mr-2" }, [
                              _vm._v("manage_search")
                            ]),
                            _vm._v("\n\t\t\t\t\tAsset ID finder\n\t\t\t\t")
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ml-0 text-none",
                            attrs: {
                              color: "warning color--text",
                              disabled: !_vm.form.parameters.asset_list.length
                            },
                            on: {
                              click: function($event) {
                                return _vm.removeAsset(-1)
                              }
                            }
                          },
                          [
                            _c("v-icon", { staticClass: "mr-2" }, [
                              _vm._v("delete")
                            ]),
                            _vm._v("\n\t\t\t\t\tVider la liste\n\t\t\t\t")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.form.parameters.hasOwnProperty("asset_list")
                  ? _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c("v-checkbox", {
                          attrs: {
                            color: "primary",
                            disabled: _vm.form.parameters.asset_list.length < 2,
                            label: "Générer un job par fichier"
                          },
                          on: {
                            change: function($event) {
                              return _vm.emitChange()
                            }
                          },
                          model: {
                            value: _vm.multiple_jobs,
                            callback: function($$v) {
                              _vm.multiple_jobs = $$v
                            },
                            expression: "multiple_jobs"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.showExplorer
              ? _c("Explorer", {
                  attrs: {
                    assetType: "file",
                    multiselect: true,
                    toolbarTitle: "Selectionnez des assets"
                  },
                  on: {
                    close: function($event) {
                      _vm.showExplorer = false
                    },
                    selectedAssets: function($event) {
                      return _vm.addAssets($event)
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showAssetFinder
              ? _c("AssetFinder", {
                  attrs: {
                    multiselect: true,
                    toolbarTitle: "Selectionnez des assets"
                  },
                  on: {
                    close: function($event) {
                      _vm.showAssetFinder = false
                    },
                    selectedAssets: function($event) {
                      return _vm.addAssets($event)
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showTitleAssetFinder
              ? _c("TitleAssetFinder", {
                  attrs: {
                    multiselect: true,
                    return_file_paths: true,
                    toolbarTitle: "Selectionnez des assets"
                  },
                  on: {
                    close: function($event) {
                      _vm.showTitleAssetFinder = false
                    },
                    selectedAssets: function($event) {
                      return _vm.addAssets($event)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e3d06fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e3d06fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/jobs/launcher/job_launcher_form_generic_vantage_job.vue
// module id = null
// module chunks = 